import { useCallback } from 'react';
import { WelcomeBoardItem, WelcomeBoardLayout } from '../../../../common/interfaces';
import { DragItem } from '../types';
import { isGridAreaOccupied } from '../utils';

export const useDragAndDrop = (
    layout: WelcomeBoardLayout,
    setLayout: React.Dispatch<React.SetStateAction<WelcomeBoardLayout>>,
    showAlertMessage: (message: string) => void
) => {
    const handleWidgetDrop = useCallback((dragItem: DragItem, column: number, row: number) => {
        if (dragItem.isNew && dragItem.widgetType) {
            // Dropping a new widget from palette
            // Check if cell is already occupied
            if (isGridAreaOccupied(column, row, layout.welcomeBoardItems)) {
                showAlertMessage('This cell is already occupied');
                return;
            }

            const newItem: WelcomeBoardItem = {
                type: dragItem.widgetType,
                gridColumn: column.toString(),
                gridRow: row.toString(),
                content: ''
            };

            setLayout(prev => ({
                ...prev,
                welcomeBoardItems: [...prev.welcomeBoardItems, newItem]
            }));
        } else if (!dragItem.isNew && dragItem.existingItem) {
            // Moving an existing widget
            const existingItem = dragItem.existingItem;
            
            // Check if target cell is already occupied by a different widget
            const otherWidgets = layout.welcomeBoardItems.filter(w => w !== existingItem);
            if (isGridAreaOccupied(column, row, otherWidgets)) {
                showAlertMessage('This cell is already occupied');
                return;
            }

            // Update the widget's position
            const updatedItem: WelcomeBoardItem = {
                ...existingItem,
                gridColumn: column.toString(),
                gridRow: row.toString()
            };

            setLayout(prev => ({
                ...prev,
                welcomeBoardItems: prev.welcomeBoardItems.map(item => 
                    item === existingItem ? updatedItem : item
                )
            }));
        }
    }, [layout.welcomeBoardItems, setLayout, showAlertMessage]);

    return {
        handleWidgetDrop
    };
};